export default "__VITE_ASSET__CSQMSHvL__"